import React from 'react'

const PhotoSelectorModal = ({
  isOpen,
  event,
  photos,
  isClearTheme,
  onClose,
  onSetDefaultPhoto
}) => {
  if (!isOpen || !event) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
      isClearTheme
        ? 'bg-black/30 backdrop-blur-lg'
        : 'bg-black/80'
    }`}>
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold" style={{color: 'var(--theme-text-primary)'}}>
            Choose Default Photo
          </h2>
          <button
            onClick={onClose}
            className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <p className="text-gray-300 mb-6">
          Select which photo should be displayed on your passport card for <strong>{event.name}</strong>
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className={`relative cursor-pointer rounded-xl overflow-hidden border-2 transition-all duration-300 ${
                event.defaultPhoto === photo.id
                  ? 'border-green-500 ring-2 ring-green-500/50'
                  : 'border-white/20 hover:border-white/40'
              }`}
              onClick={() => onSetDefaultPhoto(event._id, photo.id)}
            >
              <img
                src={photo.url}
                alt={photo.name}
                className="w-full h-32 object-cover"
              />

              {/* Selected Indicator */}
              {event.defaultPhoto === photo.id && (
                <div className="absolute inset-0 bg-green-500/20 flex items-center justify-center">
                  <div className="bg-green-500 text-white p-2 rounded-full">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                </div>
              )}

              {/* Photo Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white p-2">
                <p className="text-sm font-medium truncate">{photo.name}</p>
                {photo.type === 'stamp' && (
                  <span className="text-xs bg-green-600 px-2 py-1 rounded-full">
                    Stamp
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {photos.length === 0 && (
          <div className="text-center py-8">
            <p className="text-gray-400">No photos available for this event</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoSelectorModal